import { render, staticRenderFns } from "./VegBlogPostsCard.vue?vue&type=template&id=3b39dde8&scoped=true&"
import script from "./VegBlogPostsCard.vue?vue&type=script&lang=js&"
export * from "./VegBlogPostsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39dde8",
  null
  
)

export default component.exports